<template>
  <AppSection id="invoices" :title="$getConst.pages.invoice.invoices" type="page">
    <b-form-group id="scope" :label="$t($getConst.pages.scope.scopes)" label-for="scope-input" v-if="adminRole">
      <multiselect
        v-model="scope"
        track-by="id"
        label="name"
        :placeholder="$t(this.$getConst.pages.form.select_option)"
        :options="scopesOfConnectedRole"
        :show-labels="false"
        :searchable="true"
        @input="changeScope"
        :allowEmpty="false"
      >
        <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
      </multiselect>
    </b-form-group>
    <AppSection
      id="permissions-table"
      :title="$t($getConst.pages.invoice.list_of_invoices)"
      type="section"
      :button="hasPermission($getConst.permissions.addInvoice)"
      :button-text="$getConst.pages.button.add"
      :button-icon="$getConst.icons.add"
      second-button
      @onClick="addInvoice"
      :thirdButton="allDeleted"
      @onClickThirdButton="onDeleteItems"
    >

      <template #secondButton>
        <b-dropdown class="ml-auto" toggle-class="text-success font-weight-bold" variant="link">
          <template #button-content>
            <AppSvgIcon class="mr-2" :icon="$getConst.svgIcons.excel"/>{{$t($getConst.pages.excel.excel) | capitalize}}
          </template>
          <b-dropdown-item-button button-class="py-2 font-weight-bold" @click="exportExcel">
            {{$t($getConst.pages.excel.export) | capitalize}}<i :class="[$getConst.icons.export, 'ml-2']"/>
          </b-dropdown-item-button>
          <b-dropdown-item-button button-class="py-2 font-weight-bold" @click="openPreImportModal"
                                  v-if="hasPermission($getConst.permissions.importInvoices)">
            {{$t($getConst.pages.excel.import) | capitalize}}<i :class="[$getConst.icons.import, 'ml-2']"/>
          </b-dropdown-item-button>
          <b-dropdown-item-button button-class="py-2 font-weight-bold" @click="openProcessedInvoicesPreImportModal"
                                  v-if="hasPermission($getConst.permissions.importInvoices)">
            {{$t($getConst.pages.invoice.rapport_import_processed_invoices) | capitalize}}<i :class="[$getConst.icons.check_circle, 'ml-2']"/>
          </b-dropdown-item-button>
        </b-dropdown>
      </template>

      <AppDataTable
        :key="tableKey"
        ref="invoicesTable"
        :fields="fields"
        :end-point="endPoint"
        :actions="actions"
        @onEdit="editInvoice"
        @onDelete="confirmDelete"
        @onShow="showInvoice"
        :selectable="true"
        :withItem="true"
        :allChecked="checked"
        :headCheckbox="headCheckbox"
        @onCheckedIds="onCheckAllIds"
        @getCheckedIds="onCheckedIds"
        @onAddFilter="filtering"
      >

         <template v-slot:payment_status="item">
           <b-badge v-if="item.data === 'Awaiting'" variant="warning" pill>{{item.data}}</b-badge>
           <b-badge v-else variant="success" pill>{{item.data}}</b-badge>
        </template>
        <template v-slot:statement_date="item">
          {{formatDate(item.data)}}
        </template>
        <template v-slot:client_id="item">
          <template v-if="item.data!=null">
            {{item.data.name}}
          </template>
        </template>

      </AppDataTable>
      <PreImportRapportModal
        :scope-id="scope ? scope.id : null"
        :clients="clients"
        @importedInvoices="tableKey++"
      />
      <PreImportProcessedInvoicesModal
        :scope-id="scope ? scope.id : null"
        @importedProcessedInvoices="tableKey++"
      />
    </AppSection>
    <AppConfirmationModal
        id="confirmation-modal"
        :title=$t($getConst.pages.profile.are_you_sure) | capitalize
        ref="confirmDelete"
        @onCancel="onCancel"
        @onConfirm="deleteInvoice"/>
  </AppSection>
</template>

<script>
  import AppDataTable from "../../../components/common/table/AppDataTable";
  import AppSection from "../../../components/common/sections/AppSection";
  import PreImportRapportModal from "./PreImportRapportModal";
  import {deleteInvoice} from "../../../api/invoices.api";
  import AppConfirmationModal from "../../../components/common/modals/AppConfirmationModal";
  import {exportInvoicesByScope} from "../../../api/invoices.api";
  import PreImportProcessedInvoicesModal from "./PreImportProcessedInvoicesReportModal";
  import {getAllScopes, getDefaultScopeIdForList} from "../../../api/scopes.api";
  import {formatDateByScope} from "../../../shared/services/date";
  import {getEnabledClientByScope} from "../../../api/clients.api";


  export default {
    name: "index",
    components: {PreImportProcessedInvoicesModal, PreImportRapportModal, AppConfirmationModal, AppSection, AppDataTable},
    data() {
      return {
        headCheckbox : true,
        fields: [
          {key: 'invoice_id', label:'Invoice ID', sortable: true, filterable: true},
          {key: 'billing_period', label: 'Billing period',sortable: true, filterable: true},
          {key: 'statement_date', label: 'Statement date' ,sortable: true, filterable: 'date'},
          {key: 'payment_status', label: 'Payment status' ,sortable: true, filterable: true},
          {key: 'total_tax_amount', label: 'Total tax amount' ,sortable: true, filterable: false},
          {key: 'net_supplier_payable', label: 'Net supplier payable' ,sortable: true, filterable: false},
          {key: 'client_id', label: 'Client', sortable: true, filterable: true},
        ],
        scope: null,
        endPoint: null,
        tableKey: 0,
        actions: [
          {
            action: 'onEdit',
            variant: 'outline-secondary',
            icon: this.$getConst.icons.edit,
            permissions: [this.$getConst.permissions.updateInvoice]
          },
          {
            action: 'onDelete',
            variant: 'outline-danger',
            icon: this.$getConst.icons.delete,
            permissions: [this.$getConst.permissions.deleteInvoice]
          },
          {
            action: 'onShow',
            variant: 'outline-warning',
            icon: this.$getConst.icons.eye,
            permissions: [this.$getConst.permissions.readInvoice]
          },
        ],
        invoiceToDelete: null,
        is_loading: false,
        scopes: [],
        scopesOfConnectedRole: [],
        adminRole: null,
        checked:false,
        allDeleted:false,
        checkedIds:[],
        filters:{},
        clients:null,
      }
    },
    methods: {
      filtering(filters){
        this.filters = filters
      },
      onDeleteItems(){
        this.headCheckbox = true;
        this.confirmDelete(this.checkedIds);
      },
      onCheckedIds(CheckedIds){
        this.checkedIds=CheckedIds;
        this.checkedIds.length==0?this.allDeleted=false:this.allDeleted=true
      },
      onCheckAllIds(el){
        this.checked=el;
      },
      onCancel(){
        this.invoiceToDelete = null
        this.checked=false;
         this.allDeleted=false;
         this.checkedIds=[]
      },
      formatDate(date) {
        const formatD = formatDateByScope(date, this.$store.getters["auth/scopeDefault"].format_date, this.scope);
        return formatD;
      },
      addInvoice() {
        this.$router.push({name: this.$getConst.routesNames.addInvoice});
      },
      editInvoice(invoice) {
        this.$router.push({name: this.$getConst.routesNames.editInvoice, params: {id: invoice.id}});
      },
      showInvoice(invoice) {
        this.$router.push({name: this.$getConst.routesNames.invoiceDetails, params: {invoiceId: invoice.id}});
      },
      confirmDelete(invoice) {
        if(!Array.isArray(invoice)){
          invoice=[invoice];
        }
        this.invoiceToDelete = invoice;
        this.$bvModal.show('confirmation-modal');
      },
      deleteInvoice(){
        var items=[];
        this.invoiceToDelete.forEach(element =>
          items.push(element.id)
        );
        deleteInvoice(items).then(
          response => {
            this.invoiceToDelete.forEach(element => {
              this.$refs.invoicesTable.removeItem(element)
            });
            this.checkedIds=[];
            this.invoiceToDelete=[];
            this.allDeleted=false
            this.checked=false
            this.$refs.confirmDelete.close();
            this.$snotify.success(this.$t(this.$getConst.pages.invoice.invoice_deleted));
            },
          error => {
            this.handleApiError(error);
          }
        );
      },
      changeScope() {
          this.endPoint = '/invoicesInScope/' + this.scope.id;
        this.getEnabledClientByScope(this.scope.id)
      },
      exportExcel() {
          exportInvoicesByScope(this.scope.id,{
            responseType: 'blob',
            headers: {
              'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
          },
            this.filters
          ).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              const today = new Date();
              const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
              const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
              const dateTime = date + ' ' + time;
              link.setAttribute('download', 'invoices-' + this.scope.name + '-' + dateTime + '.xlsx')
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
            },
            (error) => {
              if (error.response.status == '406') {
                this.$snotify.error(this.$t(this.$getConst.pages.alerts.too_large_file));

              }
            });
      },
      openPreImportModal() {
        this.$bvModal.show("pre-import-rapport")
      },
      openProcessedInvoicesPreImportModal() {
        this.$bvModal.show("processed-invoices-pre-import-rapport")
      },
      getScopes() {
        getAllScopes().then(
          res => {
            this.scopes = res.data;
              this.scopesOfConnectedRole = this.scopes.filter(scope => scope.is_invoices_enabled === true)
          },
          error => this.handleApiError(error)
        );
      },
      getDefaultScopeIdForList() {
        if (this.adminRole) {
          getDefaultScopeIdForList().then(
            res => {
              this.scope = res.data;
              if (res.status === 204) {
                this.$snotify.error(this.$t(this.$getConst.pages.alerts.no_results_found));
              }
              if(this.scope){
                this.getEnabledClientByScope(this.scope.id)
              }
            },
            error => this.handleApiError(error)
          );
        } else {
          this.scope = this.$store.getters["auth/scopeDefault"];
          if(this.scope){
            this.getEnabledClientByScope(this.scope.id)
          }
        }
      },
      getEnabledClientByScope(scope_id) {
        getEnabledClientByScope(scope_id).then((res) => {
          this.clients = res.data
          this.updateFields(this.clients);
        })
      },
      updateFields(clients) {
        this.fields[7].filterable = clients.map(client => {
          return {value: client.id, text: client.name};
        });
      },
    },
    created() {
      this.endPoint = '/invoices';
      this.fields.find(field => field.key === 'payment_status').filterable = [
        {value: 'Processed', text: 'Processed'},
        {value: 'Awaiting', text: 'Awaiting'}
      ];
      this.adminRole=this.isAdmin(this.$store.getters["auth/role"]);
      if(this.adminRole) {
        this.getScopes();
      }
      this.getDefaultScopeIdForList();
    },
  }
</script>

<style lang="scss" scoped>
  .badge {
    height: inherit;
    width: 80%;
  }
  .dropdown::v-deep .dropdown-item:active {
    background: #28a745 !important;
    color: #fff !important;
  }
</style>
